// 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑
// 🛑 THIS IS AN AUTOGENERATED FILE - DO NOT EDIT DIRECTLY 🛑
// 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑 🛑
// @ts-nocheck
/* eslint-disable */
import { ENV as _ENV } from 'varlock/env';

export type CoercedEnvSchema = {
  /**
   * **NODE_ENV**  
   * Runtime environment used by Next.js and application code.  
   */
  NODE_ENV: "development" | "test" | "production";
  
  /**
   * **CI**  
   * Whether commands are running in continuous integration.  
   */
  CI: boolean;
  
  /**
   * **VERCEL_ENV**  
   * Vercel deployment environment used by the request proxy.  
   */
  VERCEL_ENV?: "development" | "preview" | "production";
  
  /**
   * **NEXT_PUBLIC_VERCEL_ENV**  
   * Public Vercel deployment environment used to resolve preview URLs.  
   */
  NEXT_PUBLIC_VERCEL_ENV?: "development" | "preview" | "production";
  
  /**
   * **NEXT_PUBLIC_VERCEL_BRANCH_URL**  
   * Public Vercel branch hostname, without a protocol.  
   */
  NEXT_PUBLIC_VERCEL_BRANCH_URL?: string;
  
  /**
   * **NEXT_PUBLIC_SITE_URL**  
   * Public URL of the website.  
   * Used for canonical URLs, metadata, and absolute links.  
   */
  NEXT_PUBLIC_SITE_URL: string;
  
  /**
   * **DATABASE_URL** 🔐 _sensitive_  
   * PostgreSQL connection string.  
   */
  DATABASE_URL: string;
  
  /**
   * **UPSTASH_REDIS_REST_URL** 🔐 _sensitive_  
   * Upstash Redis REST API endpoint.  
   *   
   * 📚 {@link https://upstash.com/docs/redis}  
   */
  UPSTASH_REDIS_REST_URL: string;
  
  /**
   * **UPSTASH_REDIS_REST_TOKEN** 🔐 _sensitive_  
   * Token used to authenticate with Upstash Redis.  
   */
  UPSTASH_REDIS_REST_TOKEN: string;
  
  /**
   * **IP_ADDRESS_SALT** 🔐 _sensitive_  
   * Secret salt used to hash IP addresses for post-like deduplication.  
   * Must remain secret and stable to preserve existing identifiers.  
   */
  IP_ADDRESS_SALT: string;
  
  /**
   * **BETTER_AUTH_SECRET** 🔐 _sensitive_  
   * Secret used for Better Auth encryption and signing.  
   * Must be a high-entropy string of at least 32 characters.  
   *   
   * 📚 {@link https://www.better-auth.com/docs/installation}  
   */
  BETTER_AUTH_SECRET: string;
  
  /**
   * **SPOTIFY_CLIENT_ID**  
   * Spotify OAuth application client ID.  
   *   
   * 📚 {@link https://developer.spotify.com/documentation/web-api}  
   */
  SPOTIFY_CLIENT_ID?: string;
  
  /**
   * **SPOTIFY_CLIENT_SECRET** 🔐 _sensitive_  
   * Spotify OAuth application client secret.  
   */
  SPOTIFY_CLIENT_SECRET?: string;
  
  /**
   * **SPOTIFY_REFRESH_TOKEN** 🔐 _sensitive_  
   * Refresh token used to access Spotify playback information.  
   *   
   * 📚 {@link https://developer.spotify.com/documentation/web-api/reference/get-the-users-currently-playing-track}  
   */
  SPOTIFY_REFRESH_TOKEN?: string;
  
  /**
   * **GOOGLE_API_KEY** 🔐 _sensitive_  
   * Google API key used to fetch YouTube statistics.  
   *   
   * 📚 {@link https://developers.google.com/youtube/v3/getting-started}  
   */
  GOOGLE_API_KEY?: string;
  
  /**
   * **GITHUB_TOKEN** 🔐 _sensitive_  
   * GitHub personal access token used to fetch GitHub statistics.  
   *   
   * 📚 {@link https://github.com/settings/tokens/new}  
   */
  GITHUB_TOKEN?: string;
  
  /**
   * **WAKATIME_API_KEY** 🔐 _sensitive_  
   * WakaTime API key used to fetch coding activity statistics.  
   *   
   * 📚 {@link https://wakatime.com/api-key}  
   */
  WAKATIME_API_KEY?: string;
  
  /**
   * **GOOGLE_CLIENT_ID**  
   * Google OAuth client ID.  
   */
  GOOGLE_CLIENT_ID?: string;
  
  /**
   * **GOOGLE_CLIENT_SECRET** 🔐 _sensitive_  
   * Google OAuth client secret.  
   */
  GOOGLE_CLIENT_SECRET?: string;
  
  /**
   * **GITHUB_CLIENT_ID**  
   * GitHub OAuth application client ID.  
   *   
   * 📚 {@link https://github.com/settings/applications/new}  
   */
  GITHUB_CLIENT_ID?: string;
  
  /**
   * **GITHUB_CLIENT_SECRET** 🔐 _sensitive_  
   * GitHub OAuth application client secret.  
   */
  GITHUB_CLIENT_SECRET?: string;
  
  /**
   * **NELSONLAI_API_KEY** 🔐 _sensitive_  
   * API key used to authenticate requests to Nelson Lai API.  
   *   
   * 📚 {@link https://api.nelsonlai.dev}  
   */
  NELSONLAI_API_KEY?: string;
  
  /**
   * **DISCORD_WEBHOOK_URL** 🔐 _sensitive_  
   * Discord webhook URL used to send notifications.  
   *   
   * 📚 {@link https://discord.com/developers/docs/resources/webhook}  
   */
  DISCORD_WEBHOOK_URL?: string;
  
  /**
   * **RESEND_API_KEY** 🔐 _sensitive_  
   * Resend API key used to send transactional emails.  
   *   
   * 📚 {@link https://resend.com/docs}  
   */
  RESEND_API_KEY?: string;
  
  /**
   * **RESEND_FROM_EMAIL**  
   * Sender email address, optionally including a display name, used for transactional emails.  
   */
  RESEND_FROM_EMAIL: string;
  
  /**
   * **AUTHOR_EMAIL**  
   * Recipient email address used for new blog comment notifications.  
   */
  AUTHOR_EMAIL?: string;
  
  /**
   * **JWT_SECRET** 🔐 _sensitive_  
   * Secret used to sign and verify JWTs.  
   */
  JWT_SECRET?: string;
  
  /**
   * **CLOUDFLARE_R2_ENDPOINT**  
   * Cloudflare R2 S3-compatible API endpoint.  
   * Included in the public Content Security Policy.  
   *   
   * 📚 {@link https://developers.cloudflare.com/r2/}  
   */
  CLOUDFLARE_R2_ENDPOINT?: string;
  
  /**
   * **CLOUDFLARE_R2_ACCESS_KEY_ID** 🔐 _sensitive_  
   * Access key ID used to authenticate with Cloudflare R2.  
   */
  CLOUDFLARE_R2_ACCESS_KEY_ID?: string;
  
  /**
   * **CLOUDFLARE_R2_SECRET_ACCESS_KEY** 🔐 _sensitive_  
   * Secret access key used to authenticate with Cloudflare R2.  
   */
  CLOUDFLARE_R2_SECRET_ACCESS_KEY?: string;
  
  /**
   * **CLOUDFLARE_R2_BUCKET_NAME**  
   * Name of the Cloudflare R2 storage bucket.  
   */
  CLOUDFLARE_R2_BUCKET_NAME?: string;
  
  /**
   * **CLOUDFLARE_R2_PUBLIC_URL**  
   * Public URL used to access files stored in Cloudflare R2.  
   */
  CLOUDFLARE_R2_PUBLIC_URL?: string;
  
  /**
   * **NEXT_PUBLIC_UMAMI_URL**  
   * Public URL of the Umami analytics instance.  
   *   
   * 📚 {@link https://umami.is/docs}  
   */
  NEXT_PUBLIC_UMAMI_URL?: string;
  
  /**
   * **NEXT_PUBLIC_UMAMI_WEBSITE_ID**  
   * Umami website identifier used for analytics tracking.  
   */
  NEXT_PUBLIC_UMAMI_WEBSITE_ID?: string;
  
};

type _CoercedEnvSchema_4ae3f599 = CoercedEnvSchema;

export type EnvSchemaAsStrings = {
  [Property in keyof CoercedEnvSchema]:
    NonNullable<CoercedEnvSchema[Property]> extends string ? NonNullable<CoercedEnvSchema[Property]>
      : (NonNullable<CoercedEnvSchema[Property]> extends boolean ? ('true' | 'false') : string)
};

type _EnvSchemaAsStrings_4ae3f599 = EnvSchemaAsStrings;

export type PublicCoercedEnvSchema = Readonly<Pick<CoercedEnvSchema, 'NODE_ENV' | 'CI' | 'VERCEL_ENV' | 'NEXT_PUBLIC_VERCEL_ENV' | 'NEXT_PUBLIC_VERCEL_BRANCH_URL' | 'NEXT_PUBLIC_SITE_URL' | 'SPOTIFY_CLIENT_ID' | 'GOOGLE_CLIENT_ID' | 'GITHUB_CLIENT_ID' | 'RESEND_FROM_EMAIL' | 'AUTHOR_EMAIL' | 'CLOUDFLARE_R2_ENDPOINT' | 'CLOUDFLARE_R2_BUCKET_NAME' | 'CLOUDFLARE_R2_PUBLIC_URL' | 'NEXT_PUBLIC_UMAMI_URL' | 'NEXT_PUBLIC_UMAMI_WEBSITE_ID'>>;

// re-export of the runtime ENV proxy, typed to this package's schema
export const ENV = _ENV as unknown as Readonly<CoercedEnvSchema>;
